import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const LearnerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
        icon: 'navigation-link__home',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.assignment_learner',
                link: '/followed/tab/list',
                icon: 'navigation-link__assignments',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.corpus_group',
                icon: 'navigation-group__corpus',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.corpus_global',
                        link: '/corpus/11057',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.class_media_library',
                        link: '{{USER_CORPUS_LINK}}',
                        icon: 'navigation-link__list-item',
                    },
                ],
            },
        ],
    },
    {
        type: 'linkGroup',
        label: 'navigation.educational_tools',
        links: [
            {
                type: 'link',
                label: 'navigation.notepad',
                link: '/notepad/list',
                icon: 'navigation-link__notepad',
            },
            {
                type: 'link',
                label: 'navigation.mindmap',
                link: '/mindmap/list',
                icon: 'navigation-link__mindmap',
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'imageLink',
                label: 'navigation.offered_by',
                icon: 'navigation__offered-by',
                src: '{{OFFERED_BY_SRC}}',
                actionToken: '{{OFFERED_BY_ACTION}}',
            },
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.who_are_we',
                link: '/page/qui-sommes-nous',
                icon: 'navigation-link__who-are-we',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
